import React from 'react'
import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import PracticeSelectView from '../Practices/PracticeSelectView'

export default function Orders() {
  return (
    <div>
      <PageHeader title="Orders - Select Practice" />
      <PracticeSelectView routeMethod={toPath.practices.ordersTabs} />
    </div>
  )
}
